import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { usePortalAuthStore } from '@/store/portal-auth.store';
import type { PortalSessionToken } from '@/store/portal-auth.store';

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

export function PortalOAuthCompletePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { login } = usePortalAuthStore();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const sessionToken = params.get('sessionToken');
    const dest = params.get('dest') ?? '/portal/home';

    if (!sessionToken) {
      navigate('/portal/login?error=missing_token', { replace: true });
      return;
    }

    const payload = decodeJwtPayload(sessionToken);
    const vendorAccountId = payload?.vendorAccountId as string | undefined;

    if (!vendorAccountId) {
      navigate('/portal/login?error=invalid_token', { replace: true });
      return;
    }

    login(sessionToken as PortalSessionToken, vendorAccountId);
    navigate(dest, { replace: true });
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-base">
      <div className="flex flex-col items-center gap-3 text-text-secondary">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="text-sm">Completing sign in…</span>
      </div>
    </div>
  );
}
